// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-K":"K_shp2-detail-K__8V2Ws"};